import { render, staticRenderFns } from "./KhUserAdd.vue?vue&type=template&id=6613f2be&scoped=true"
import script from "./KhUserAdd.vue?vue&type=script&lang=js"
export * from "./KhUserAdd.vue?vue&type=script&lang=js"
import style0 from "./KhUserAdd.vue?vue&type=style&index=0&id=6613f2be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6613f2be",
  null
  
)

export default component.exports